import { useEffect } from "react";

/**
 * Everything a client can see on their adviser's address has to be the adviser's
 * — including the browser tab, the favicon and the description a link preview
 * picks up. Restores the operator values when they leave the partner surface.
 */
export default function useWhiteLabelHead(brand) {
  const name = brand?.name || "";
  const logo = brand?.logo || "";
  const text = brand?.tagline || brand?.about_text || "";

  useEffect(() => {
    if (!name) return undefined;

    const head = document.head;
    const pick = (sel) => head.querySelector(sel);
    const desc = pick('meta[name="description"]');
    const icons = Array.from(head.querySelectorAll('link[rel~="icon"], link[rel="apple-touch-icon"]'));

    const prev = {
      title: document.title,
      desc: desc?.getAttribute("content") || null,
      icons: icons.map((l) => ({ el: l, href: l.getAttribute("href") })),
    };

    document.title = name;
    if (desc) {
      desc.setAttribute("content", text
        ? String(text).replace(/\s+/g, " ").slice(0, 180)
        : `${name} — client area.`);
    }
    icons.forEach((l) => l.setAttribute("href", logo || "data:,"));

    return () => {
      document.title = prev.title;
      if (desc && prev.desc !== null) desc.setAttribute("content", prev.desc);
      prev.icons.forEach(({ el, href }) => (href ? el.setAttribute("href", href) : el.removeAttribute("href")));
    };
  }, [name, logo, text]);
}
